import * as React from 'react';
// mui
import {
  ListItemText,
  Typography,
} from '@mui/material';
// icons
import ElectricBoltIcon from '@mui/icons-material/ElectricBolt';
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
import FlagIcon from '@mui/icons-material/Flag';
import NotesIcon from '@mui/icons-material/Notes';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
// redux
import { useSelector } from 'react-redux';
import { selectRecurringTaskById } from '../../../store/selectors/recuringTaskSelectors';
import { selectProjectById } from '../../../store/selectors/projectSelectors';
// types
import RecurringTask from '../../../interfaces/RecurringTask.interface';
import Project from '../../../interfaces/Project.interface';
// components
import { convertEnergyToString, convertPriorityToString, convertTimeToMinutesString } from '../../common/propertyValueToString';
import ItemContentDate from '../../common/ItemContentDate';
import dayjs from 'dayjs';

interface TaskListItemContentProps {
  recurringTaskId: number;
  showProject?: boolean;
}
const dayNameMap = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

export default function RecurringTaskItemContent(props: TaskListItemContentProps) {
  // props
  const { recurringTaskId } = props;
  const showProject = props.showProject || false;

  // redux
  const localRecurringTask: RecurringTask = useSelector(selectRecurringTaskById(recurringTaskId)) as RecurringTask;
  const localProject: Project = useSelector(selectProjectById(localRecurringTask.projectId)) as Project;

  let isLocalRecurringTaskInactive: boolean = false;
  if (localRecurringTask.interval === 'daily') {
    isLocalRecurringTaskInactive = !localRecurringTask.selectedDays?.includes(dayNameMap[dayjs().day()]) || false;
  }

  return (
    <ListItemText
      sx={{ color: localRecurringTask.completed
                || localRecurringTask.permanentlyCompleted
                || localRecurringTask.excused ? 'grey' : 'inherit'}}
      primary={localRecurringTask.title}
      secondary={
        <Typography
          variant={'caption'}
          sx={{color: localRecurringTask.completed || localRecurringTask.permanentlyCompleted ? 'grey' : '#9e9e9e'}}
        >
          { localRecurringTask.description &&
            <NotesIcon sx={{
              height: '18px',
              width: '20px',
              marginBottom: '-4px',
              marginLeft: '4px',
              mr: '4px'
            }}/>
          }

          <ItemContentDate
            itemData={localRecurringTask}
            itemType="recurring"
            forceGrey={isLocalRecurringTaskInactive}
          />

          {/* task info icons */}
          <FlagIcon sx={{
            height: '18px',
            width: '20px',
            marginBottom: '-4px',
            marginLeft: '4px'
          }} />{convertPriorityToString(localRecurringTask.priority)} 

          <ElectricBoltIcon sx={{
            height: '18px',
            width: '20px',
            marginBottom: '-4px',
            marginLeft: '4px'
          }} />{convertEnergyToString(localRecurringTask.energy)} 

          <AccessAlarmIcon sx={{
            height: '18px',
            width: '20px',
            marginBottom: '-4px',
            marginLeft: '8px'
          }} />{convertTimeToMinutesString(localRecurringTask.time)}

          { showProject && (
            <React.Fragment>
              <FolderOpenIcon sx={{
                height: '18px',
                width: '20px',
                marginBottom: '-4px',
                ml: '5px',
                mr: '1px',
              }}/>{localProject.name}
            </React.Fragment>
          )}
        </Typography>
      }
    />
  )
}